import { ShelfItemBookEntity } from "@/app/entities/ShelfEntity"
import { ToBookItemProps } from "../_types"

/**
 * ShelfItemBookEntity를 UI Props로 변환
 * ReadLog v3 Entity 기반 타입 시스템 준수
 */
export const toBookItemProps: ToBookItemProps = (entity) => ({
  id: entity.id,
  title: entity.title,
  authors: entity.creators?.join(", ") || "작가 정보 없음",
  thumbnailUrl: entity.thumbnailUrl,
  isbn: entity.isbn || undefined,
  isSelected: false, // 기본값, 실제 선택 상태는 상위에서 관리
})

/**
 * ISBN이 유효한지 확인
 */
export const isValidIsbn = (isbn?: string | null): boolean => {
  return Boolean(isbn && isbn.trim() !== "")
}

/**
 * 선택된 도서들의 유효한 ISBN 목록 추출
 */
export const getValidSelectedIsbns = (
  selectedBooks: Set<string>,
  books: ShelfItemBookEntity[]
): string[] => {
  return Array.from(selectedBooks).filter((isbn) => {
    const book = books.find((b) => b.isbn === isbn)
    return book && isValidIsbn(book.isbn)
  })
}